<template>
	<div class="top-tags">
		<div class="tags-body">
			<p><a href="#" @click="this.$router.push('/')">首页</a> > <a href="#"
					@click="this.$router.push('/Reting')">查询鉴定</a></p>
		</div>
	</div>
	<div class="zhu-about">
		<h3>查询鉴定</h3>
		<!-- <div class="sousuo">
            <el-input
                placeholder="请输入评级编号"
                class="input-with-select"
                size="large"
                v-model="ratingValTest"
            >
                <template #append>
                <el-button @click="goReting()">点击查询</el-button>
                </template>
            </el-input>
        </div> -->
		<h4>查询编号: &nbsp;&nbsp;<span>{{ratingVal}}</span></h4>
		<div class="about">
			<div class="about_us">

				<div class="about-logo" v-if="showData">
					<!-- <img src = "../assets/logo.png"/> -->
					<el-carousel height="450px">
						<el-carousel-item v-for="item in imgList" :key="item">
							<el-image style="width: 100%; height: 100%" :src="item.url"></el-image>
						</el-carousel-item>
					</el-carousel>
				</div>

				<div class="about-text">
					<div class="about-content">
						<ul v-if="showData">
							<li><a>名称：</a><span>{{coinInfo.coinName}}</span></li>
							<li><a>朝代：</a><span>{{coinInfo.dynasty}}</span></li>
							<li><a>版别面值：</a><span>{{coinInfo.versionFace}}</span></li>
							<li><a>等级：</a><span>{{coinInfo.grade}}</span></li>
							<li><a>分数：</a><span>{{coinInfo.score}}</span></li>
							<li><a>尺寸：</a><span>{{coinInfo.size}}</span></li>
							<!-- <li><a>代码标注：</a><span>{{coinInfo.code}}</span></li>
							<li><a>备注：</a><span>{{coinInfo.remark}}</span></li> -->
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>
<script>
	export default {
		data() {
			return {
				//查询鉴定
				ratingVal: '',
				ratingValTest: '',
				imgList: [{
					url: '../assets/img/img.jpg'
				}],
				coinInfo: {
					dynasty: '',
					coinName: 'AA',
					versionFace: '',
					grade: '',
					score: '',
					size: '',
					code: '',
					remark: '',
				},
				showData: false
			}
		},
		mounted() {
			this.ratingVal = this.$route.params.name
		},
		methods: {
			// //查询鉴定
			// goReting () {
			//     this.ratingVal = this.ratingValTest
			// }
			search() {
				//this.axios.get('http://127.0.0.1:8081/zqjd/rating/coin/home/' + this.ratingVal).then((response) => {
				this.axios.get('http://api.zhengquanpj.com/rating/coin/home/' + this.ratingVal).then((response) => {
					let data = response.data;
					if (data.code == 0) {
						if (data.coinInfo == null) {
							this.$notify.error({
								title: '温馨提示',
								message: '未查询到相关信息,请检查证书编号是否正确!'
							});
							this.showData = false
							return;
						}
						let coinInfo = data.coinInfo
						this.showData = true
						this.coinInfo.dynasty = coinInfo.dynasty
						this.coinInfo.coinName = coinInfo.coinName
						this.coinInfo.code = coinInfo.code
						this.coinInfo.grade = coinInfo.grade
						this.coinInfo.score = coinInfo.score
						this.coinInfo.versionFace = coinInfo.versionFace
						this.coinInfo.size = coinInfo.size
						this.coinInfo.remark = coinInfo.remark
						let imgList = coinInfo.imgList
						if (imgList != null && imgList.length > 0) {
							this.imgList = []
							for (const ele of imgList) {
								let img = {
									url: ele.imgUrl
								}
								this.imgList.push(img)
							}
						}
					} else if (data.code == 400) {
						this.$notify.error({
							title: '警告',
							message: '您输入的内容非法,请正确使用查询服务!'
						});
						this.showData = false
					} else {
						this.$notify.warning({
							title: '提示',
							message: '检索服务异常,请联系管理员处理!'
						});
						this.showData = false
					}
				})
			}
		},
		watch: {
			$route: function(toPath) {
				this.ratingVal = toPath.params.name
			},
			ratingVal(newdata, oldata) {
				if (typeof newdata === 'undefined' || newdata == '') {
					return
				}
				this.search()
			}
		},

	}
</script>
<style lang="scss" scoped>
	//-------------------------------小跳转菜单
	.top-tags {
		width: 100%;
		height: 40px;
		background: #f3f3f3;

		.tags-body {
			width: 1210px;
			margin: 0 auto;
			border: 1px solid #f3f3f3;
			text-align: left;
			position: relative;

			@media only screen and (max-width: 1210px) {
				width: 100%;
			}

			p {
				margin-top: 10px;
				padding-left: 5px;
				border-left: 6px solid #409EFF;

				a {
					color: #303133;
					font-size: 14px;
					text-decoration: none;

					&:hover {
						color: #409EFF;
					}
				}
			}
		}
	}



	.zhu-about {
		width: 1400px;
		margin: 0 auto;

		@media only screen and (max-width: 1400px) {
			width: 100%;
		}
		@media only screen and (max-width:850px) {
			width: 100%;
			height: 37.5rem;
		}
		@media only screen and (max-width: 450px) {
			width: 100%;
			height: 46.875rem;
		}

		h3 {
			@media only screen and (max-width: 810px) {
				width: 90%;
				margin: 20px 5%;
			}

			font-size: 24px;
			text-align: left;
			margin: 20px 96px;
			padding: 10px 0;
			border-bottom: 1px solid #DFDFDF;
			position: relative;

			&::after {
				content: "";
				position: absolute;
				left: 48px;
				bottom: -1px;
				width: 100px;
				height: 2px;
				margin-left: -50px;
				background-color: #409EFF;
			}
		}

		.sousuo {
			width: 80%;
			margin: 0 auto;
			margin-top: 30px;
			margin-bottom: 30px;
		}

		//-----------------------------------------------主题-----------------------------------------------

		.about {
			width: 1400px;
			margin: 0 auto;
			height: 450px;

			@media only screen and (max-width: 1400px) {
				width: 100%;
			}

			@media only screen and (max-width: 520px) {
				height: 500px;
			}

			@media only screen and (max-width: 420px) {
				height: 550px;
			}

			@media only screen and (max-width: 380px) {
				height: 650px;
			}

			h5 {
				margin-top: 30px;
			}

			.about_us {
				display: flex;

				@media only screen and (max-width: 700px) {
					display: block;
				}

				.about-logo {
					margin-top: 0.625rem;
					margin-left: 5.3125rem;
					width: 25%;

					@media only screen and (max-width: 700px) {
						margin-left: 0rem;
						width: 100%;
					}

					img {
						margin-top: 30px;
						margin-left: 100px;
						width: 160px;

						@media only screen and (max-width: 1179px) {
							margin-left: 20%;
						}

						@media only screen and (max-width: 700px) {
							margin: auto 0;
							margin-top: 20px;
						}
					}
				}

				.about-text {
					.about-content {
						margin-top: 50px;
						margin-left: 168px;
						margin-bottom: 30px;

						@media only screen and (max-width: 700px) {
							margin-left: 10%;
						}

						@media only screen and (max-width: 500px) {
							margin-left: 5%;
						}

						@media only screen and (max-width: 450px) {
							margin-top: 16px;
							margin-left: 2%;
						}

						ul {
							margin: auto 0;

							@media only screen and (max-width: 700px) {
								width: 100%;
							}

							li {
								list-style: none;
								padding: 10px;
								text-align: left;
								border-bottom: 1px solid #DFDFDF;
								display: flex;
								color: #000;

								&:nth-last-child(1) {
									display: block;
									border-bottom: 0;

								}

								span {
									color: #666666;
								}
							}
						}
					}
				}
			}
		}

	}
</style>
